const loadDriver = async (theapp, device) => {
	require('../wallets/remote-wallet.js');
	require('../wallets/metamask.js');
	require('../wallets/gooddollar.js');

	let start_conditions = theapp.getStartConditions();

	if (!start_conditions)
	return;

	// find driver for specified wallet (if any)
	let mvcmywidget = theapp.getMvcMyWidget();
	
	let _wallet_driver = start_conditions.remote_wallet_driver;

	let ismobile = (device && (device === 'mobile') ? true : theapp.checkMobile());


	if (ismobile) {
		// is driver overloaded for mobile
		_wallet_driver = (start_conditions.mobile_wallet_driver ? start_conditions.mobile_wallet_driver : _wallet_driver);
	}
	else {
		// is driver overloaded for mobile
		_wallet_driver = (start_conditions.desktop_wallet_driver ? start_conditions.desktop_wallet_driver : _wallet_driver);
	}

	const remote_wallet_driver = _wallet_driver;
	
	let RemoteWallet;
	let remotewallet;

	switch(remote_wallet_driver) {
		case 'MetaMask':
			RemoteWallet = mvcmywidget.getRegisteredClass('MetaMask');
			break;				
		case 'GoodDollar':
			RemoteWallet = mvcmywidget.getRegisteredClass('GoodDollar');
			break;				
		default:
			RemoteWallet = mvcmywidget.getRegisteredClass('RemoteWallet');
			break;
	}

	if (RemoteWallet) {
		remotewallet = new RemoteWallet(theapp);
	}

	return remotewallet;
}

export default loadDriver;